import Auth from '@/store/modules/auth/constants';
import { buildRules } from '@/helpers/caslHelper';
import { AbilityBuilder } from '@casl/ability';

function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item;
  }

  // eslint-disable-next-line no-underscore-dangle
  return item.__type;
}

export const ability = AbilityBuilder.define({ subjectName }, () => {

});

export const abilityPlugin = (store) => {
  if (store.state.auth.userInfo.roles) {
    const { roles, id, clients } = store.state.auth.userInfo;

    ability.update(buildRules(id, roles, clients));
  }

  return store.subscribe((mutation) => {
    if (mutation.payload) {
      const { roles, id, clients } = mutation.payload;

      switch (mutation.type) {
        case `auth/${Auth.mutationTypes.setUserInfo}`:
          if (!roles) {
            ability.update([]);
          } else {
            const rules = buildRules(id, roles, clients);

            ability.update(rules);
          }
          break;

        default:
          break;
      }
    }
  });
};
